export default __webpack_public_path__ + "static/media/draft.9de4ba56.png";